<template>
  <div class="pb9">
    <AppEditProductsDialog></AppEditProductsDialog>
    <v-card>
      <v-card-title>
        <v-spacer></v-spacer>

        <v-combobox
          v-if="categoriesList"
          @change="filterByCategory"
          :items="categoriesList"
          :search-input.sync="categorySearch"
          hide-selected
          clearable
          label="Filter by category"
        >
          <template slot="item" slot-scope="props">
            {{ props.item.cascade_name }}
          </template>
          <template slot="selection" slot-scope="props">
            {{ props.item.cascade_name }}
          </template>
        </v-combobox>
      </v-card-title>

      <v-data-table
        :headers="tableHeaders"
        :items="products"
        class="elevation-1"
        :loading="loadingInProgress"
        :no-data-text="loadingOrNoItemsText"
        :rows-per-page-items="rowsPerPageItems"
        :pagination.sync="pagination"
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.item.id }}</td>
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.price }}</td>
          <td>{{ props.item.commission }}</td>
          <td>{{ props.item.amount }}</td>
          <td>{{ props.item.category ? props.item.category.name : 'N/A' }}</td>
          <td>{{ props.item.user ? props.item.user.name : 'N/A' }}</td>
          <td class="justify-left layout px-0">
            <v-btn icon class="mx-0" @click="editElement(props.item.id)">
              <v-icon color="teal">edit</v-icon>
            </v-btn>
            <v-btn icon class="mx-0" @click="deleteDialog(props.item.id)">
              <v-icon color="pink">delete</v-icon>
            </v-btn>
            <confirmation-dialog ref="confirm"></confirmation-dialog>
          </td>
        </template>
      </v-data-table>
      <AddProductButton/>
    </v-card>
  </div>
</template>

<script>
  import AddProductButton from '@/components/buttons/AddProductButton'
  import AppEditProductsDialog from '@/components/dialogs/AppEditProductsDialog'
  import resourcesMixins from '@/mixins/Resources'
  import ConfirmationDialog from '@/components/dialogs/ConfirmationDialog'
  import { mapGetters } from 'vuex'

  export default {
    name: 'Products',
    components: { AddProductButton, AppEditProductsDialog, ConfirmationDialog },
    mixins: [ resourcesMixins ],
    data () {
      return {
        resources: 'products',
        categorySearch: null,
        tableHeaders: [
          { text: 'ID', value: 'id' },
          { text: 'Name', value: 'name' },
          { text: 'Unit Price ($)', value: 'price' },
          { text: 'Commission', value: 'commission' },
          { text: 'Default amount', value: 'amount' },
          { text: 'Category', value: 'category' },
          { text: 'Vendor', value: 'vendor' },
          { text: 'Actions', value: 'actions' }
        ],
        rowsPerPageItems: [10, 20, 30, 40, { 'text': '$vuetify.dataIterator.rowsPerPageAll', 'value': -1 }],
        pagination: {
          descending: true,
          rowsPerPage: 10,
          sortBy: 'id'
        },
        loadingOrNoItemsText: 'Loading items...'
      }
    },
    computed: {
      ...mapGetters({
        products: 'filteredProducts',
        removeCasketsFromServices: 'removeCasketsFromServices',
        categoriesList: 'productsCategories',
        categoryById: 'getProductCategoryById'
      })
    },
    watch: {
      products (newItems) {
        this.loadingInProgress = false
        if (newItems.length === 0) {
          this.loadingOrNoItemsText = 'No items'
        }
      }
    },
    methods: {
      filterByCategory (category) {
        this.$store.dispatch('filterProducts', category === undefined ? null : category)
      },
      deleteDialog (id) {
        this.$refs.confirm.open('Are you sure?', 'Delete', {}).then((confirm) => {
          this.deleteElement(id)
        })
      },
      loadListing () {
        this.$store.dispatch('getAllProducts').then(() => {
          this.loadingInProgress = false
        })
      }
    },
    created () {
      if (this.$store.state.products.categories.length === 0) this.$store.dispatch('getProductsCategories')
      this.loadListing()
    }
  }
</script>



// WEBPACK FOOTER //
// Products.vue?61d31de0